/* Fonctions globales
 *********************************************************************************************/
function stylizedRadioButton() {
    $('.custom-radio-button a').on('click', function() {
        var clickedButton = $(this);
        var nameRadioButton = $(this).parent().data('name');
        var currentActiveButton = $(".custom-radio-button .active");
        // Si on clique sur un bouton non actif
        if (clickedButton.data('value') != currentActiveButton.data('value')) {
            clickedButton.removeClass('notActive').addClass('active');
            currentActiveButton.removeClass('active').addClass('notActive');
            $(".radio-value-" + nameRadioButton).attr("value", clickedButton.data('value'));
        }
    });
}
window.stylizedRadioButton = stylizedRadioButton;


/**
 * * [Permet de scroller automatiquement jusqu'à un element]
 * @param  {[string]} element [class ou id de l'élément sur lequel on a cliqué ]
 * @return -
 */
function scrollToAncre(element = null) {
    if (element){
        $(element).on('click', 'a', function(event){
            event.preventDefault();
            // Scroll auto
            $('html, body').animate(
                { scrollTop: $( $.attr(this, 'href') ).offset().top - 60 }, 800
            );
        });
    }
}
window.scrollToAncre = scrollToAncre;



/* Listeners
 *********************************************************************************************/
// Gestion de l'indicateur pays en fonction du champs pays choisi
$('#indicatif-telephone').text($('#form-pays').find(":selected").data('indictel'));
$('#form-pays').on('change', function(e) {
    $('#indicatif-telephone').text($(e.currentTarget.selectedOptions).data('indictel'));
});
